import axios from "axios";
import { apiRequest } from "../util/apiUtils";
// import { countries } from "../db/countries";

export const getCountryList = async (params) => {
  try {
    const res = await apiRequest("get", `application-form/country-list`, {
      queries: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};
